<template>
    <div class="search-result">
      <div class="search-result__wrapper">
        <div class="plants-list">
          <a
              v-if="result.length"
              v-for="item in result"
              :key="item.id"
              class="plants-list-item"
              :data-bs-toggle="!isAuth ? 'modal' : null"
              :href="isAuth ? `/plants/${item.id}` : '#getAccessModal'"
          >
            <img
                :src="`/static/images/plants/${getImgName(item.name, 'jpg')}`"
                :alt="item.name"
                class="plants-list-item__img"
            >
            {{ item.name }}
          </a>
          <span v-else class="plants-list-item">

             <img
                 src="@/assets/images/icons/search-no-result.png"
                 alt="No results"
                 class="plants-list-item__img"
             >
            No results
          </span>
        </div>
      </div>
    </div>
</template>

<script>
import createImageName from "@/helpers/createImageName.js";
import {useAuthStore} from "@/stores/index.js";
export default {
  props: {
    result: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      authStore: useAuthStore()
    }
  },
  computed: {
    isAuth() {
      return this.authStore.isAuth;
    }
  },
  methods: {
    getImgName(name, type) {
      return createImageName(name, type);
    }
  }
};
</script>

<style
  lang="scss"
  scoped
>
.search-result {
  position: absolute;
  top: calc(100% + 20px);
  left: 0;
  right: 0;
  z-index: 10;

  &__wrapper {
    background-color: $white;
    padding: 16px;
    border-radius: 32px;
    border: 1px solid $green-shade;

    .plants-list {
      display: flex;
      flex-wrap: wrap;
      gap: 16px;

      &-item {
        font-size: 20px;
        padding: 8px;
        background: $green-shade;
        display: flex;
        align-items: center;
        gap:8px;
        border-radius: 8px;

        &__img {
          width: 40px;
          height: 40px;
          border-radius: 8px;
        }
      }
    }
  }
}
</style>